/**
 * Checks whether the bandwidth controls provided exist and are numbers.
 * @param {BandwidthControls} bandwidthControls The bandwidth controls to check.
 */
export function checkBandwidthControls (bandwidthControls) {
  const finalBandwidthControls = { ...bandwidthControls }

  // If there are no bandwidth limits set or the bandwidth limits provided are not numbers, set them to undefined
  if (!bandwidthControls || !(bandwidthControls.audio && typeof bandwidthControls.audio === 'number')) {
    finalBandwidthControls.audio = null
  }
  if (!bandwidthControls || !(bandwidthControls.video && typeof bandwidthControls.video === 'number')) {
    finalBandwidthControls.video = null
  }
  return finalBandwidthControls
}
